(function() {
  'use strict';

  // DENY-list, not an allow-list, and the asymmetry is the whole argument.
  //
  // Form IDs are minted whenever marketing builds a form, which happens without
  // anyone touching the theme. An allow-list compiled into a theme asset means
  // the next new email form contributes ZERO newsletter_signup events forever,
  // with no error and nothing in the data to notice -- a floor that reads as a
  // level. Live evidence: four distinct form IDs have submitted on this store in
  // four months (XriDnB, RyhFAw, S7zGmC, VyZw9d) and two are already dark.
  //
  // A stray SMS form miscounted as a newsletter signup is visible and fixable in
  // an afternoon. A missing email form is invisible indefinitely. So publish for
  // every Klaviyo submit and deny only the known SMS forms.
  //
  // The published payload already carries formId, so any further filtering
  // belongs downstream where it is revisable without a theme deploy.
  const KLAVIYO_SMS_FORMS = new Set([
    'S7zGmC' // SMS signup -- deliberately not a newsletter_signup
  ]);

  function publishNewsletterSignup(method, formId, formVersionId) {
    if (!window.Shopify?.analytics?.publish) {
      return false;
    }

    const eventData = {
      method: method,
      formId: formId || '',
      formVersionId: formVersionId || ''
    };

    Promise.resolve(
      window.Shopify.analytics.publish('newsletter_signup', eventData)
    ).catch(function() {
      // A measurement failure must never interrupt the customer flow.
    });

    return true;
  }

  window.addEventListener('klaviyoForms', function(event) {
    const detail = event?.detail;
    if (detail?.type !== 'submit' || KLAVIYO_SMS_FORMS.has(detail.formId)) {
      return;
    }

    publishNewsletterSignup(
      'klaviyo_newsletter',
      detail.formId,
      detail.formVersionId
    );
  });

  function publishNativeNewsletterSuccesses() {
    // Publish at most once per page load, regardless of how many success nodes
    // are rendered. The snippet is included from four places (footer, newsletter,
    // pop-up, main-product) and several co-occur -- a product page with a
    // newsletter block plus the footer renders three instances. Whether
    // `form.posted_successfully?` is true for every {% form 'customer' %} on the
    // page or only the submitted one is NOT stated by Shopify's reference, which
    // says only "Returns true if the form was submitted successfully".
    //
    // Rather than over-read that reference into a guarantee it never made, this
    // sidesteps the question: one page load is at most one native signup, so take
    // the first node and return. Stays correct either way, and stays correct if
    // the Liquid behaviour changes under us.
    const success = document.querySelector('[data-newsletter-signup-success]');
    if (!success) {
      return;
    }

    publishNewsletterSignup(
      'shopify_newsletter',
      success.dataset.newsletterFormId,
      ''
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      publishNativeNewsletterSuccesses,
      { once: true }
    );
  } else {
    publishNativeNewsletterSuccesses();
  }
})();
